export const ZipRegex = (countryCode) => {
  if (countryCode == 'USA') {
    return {
      regex: /^[\d]{5}$/,
      msg: 'Invalid format. Use format NNNNN.'
    }
  }
  else if (countryCode == 'CAN') {
    return {
      regex: /^[A-Z]{1}[\d]{1}[A-Z]{1} [\d]{1}[A-Z]{1}[\d]{1}$/,
      msg: 'Invalid format. Use format ANA NAN.'
    }
  }
  else if (countryCode == 'IND') {
    return {
      regex: /^[\d]{6}$/,
      msg: 'Invalid format. Use format NNNNNN.'
    }
  }
  else if (countryCode == 'COL') {
    return {
      regex: /^[\d]{6}$/,
      msg: 'Invalid format. Use format NNNNNN.'
    }
  }
  else if (countryCode == 'MEX') {
    return {
      regex: /^[\d]{5}$/,
      msg: 'Invalid format. Use format NNNNN.'
    }
  }
  else if (countryCode == 'PHL') {
    return {
      regex: /^[\d]{4}$/,
      msg: 'Invalid format. Use format NNNN.'
    }
  }
  else if (countryCode == 'POL') {
    return {
      regex: /^[\d]{1}[\d]{1}-[\d]{1}[\d]{1}[\d]{1}$/,
      msg: 'Invalid format. Use format NN-NNN.'
    }
  }
  else if (countryCode == 'EGY') {
    return {
      regex: /^[\d]{7}$/,
      msg: 'Invalid format. Use format NNNNNNN.'
    }
  }
  else if (countryCode == 'AUS') {
    return {
      regex: /^[\d]{4}$/,
      msg: 'Invalid format. Use format NNNN.'
    }
  }
  else
    return null
}
